module.exports = __webpack_public_path__ + "img/meeting_intro_3.bde24a50.png";